import { ContactPerson } from '../types/contactPerson'

export const getContactPersonsWithoutPrimaryContact = (contactPersons?: ContactPerson[]): ContactPerson[] =>
  contactPersons?.filter((contact) => !contact.isPrimary) ?? []
